import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {MeshGeometryAttributeSetRecordInput} from "#template/nodes/geometry-graph/attribute-set/attribute-set-record-input/mesh-geometry-attribute-set-record-input"
import {MeshGeometryAttributeSetMeshLikeInput} from "#template/nodes/geometry-graph/attribute-set/mesh-geometry-attribute-set-mesh-like-input"
import type {MeshGeometryAttributeSetRecordInputParameters} from "#template/nodes/geometry-graph/attribute-set/attribute-set-record-input/mesh-geometry-attribute-set-record-input"
import type {MeshGeometryAttributeSetMeshLikeInputParameters} from "#template/nodes/geometry-graph/attribute-set/mesh-geometry-attribute-set-mesh-like-input"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {IModifyTemplateGraph} from "#template/interactions"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {AttributeSetParameters} from "#template/nodes/geometry-graph/attribute-set/attribute-set-builder/geometry-attribute-set-builder-node"
import {GeometryAttributeSetBuilderNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-builder/geometry-attribute-set-builder-node"

export type MeshGeometryAttributeSetParameters = AttributeSetParameters<MeshGeometryAttributeSetRecordInput | MeshGeometryAttributeSetMeshLikeInput>

export interface SetMeshGeometryAttributeSetInput {
    setObjectLikeInput(parameters: MeshGeometryAttributeSetMeshLikeInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void
    setRecordInput(parameters: MeshGeometryAttributeSetRecordInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void
}

const definition: TemplateNodeDefinition<MeshGeometryAttributeSetParameters> = {
    nodeClass: "MeshGeometryAttributeSet",
    validation: {
        parameters: z.object({
            name: z.string(),
            input: z.union([graphNode(MeshGeometryAttributeSetRecordInput), graphNode(MeshGeometryAttributeSetMeshLikeInput)]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryAttributeSet
    extends GeometryAttributeSetBuilderNode<2, MeshGeometryAttributeSetRecordInput | MeshGeometryAttributeSetMeshLikeInput>
    implements MeshGeometryAttributeSetLikeNode, SetMeshGeometryAttributeSetInput
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
    setObjectLikeInput(parameters: MeshGeometryAttributeSetMeshLikeInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void {
        modifyTemplateGraph.modifyTemplateGraph(() =>
            this.updateParameters({
                input: new MeshGeometryAttributeSetMeshLikeInput({parameters: parameters ? {...parameters} : {mesh: null, numUVChannels: null}}),
            }),
        )
    }

    setRecordInput(parameters: MeshGeometryAttributeSetRecordInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void {
        modifyTemplateGraph.modifyTemplateGraph(() =>
            this.updateParameters({input: new MeshGeometryAttributeSetRecordInput({parameters: parameters ? {...parameters} : {record: {}}})}),
        )
    }
}
